import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";

export const ReferralSourcesEmptyState = () => (
  <Stack direction="column" gap="sm" align="center">
    <Typography variant="bodyW1" textColor="secondary" className="text-center">
      No referral sources set up yet.{" "}
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-pointer items-center gap-1 text-interactive-text">
            What is a referral source?
          </span>
        </TooltipTrigger>
        <TooltipContent maxWidth="lg" className="p-4">
          <Stack gap="md" className="max-w-sm">
            <Typography variant="bodyW2" textColor="primaryInverse">
              A <strong>referral source</strong> is a way to get an attribution
              code that is not linked to a user. Have a promotion you are
              running? Want a code for a specific event where you have someone
              getting signups for your program?
            </Typography>
            <Typography variant="bodyW2" textColor="primaryInverse">
              All you have to do is click the <strong>New source</strong> button
              in the top right corner of the screen. There you can name and
              describe whatever signup source you want to track independently.
            </Typography>
          </Stack>
        </TooltipContent>
      </Tooltip>
    </Typography>
  </Stack>
);
